import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutHero() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="http://geel.fp.08wx.cn/images/f2e99904074058e383914d8d9818232c.jpg"
          alt="About Hero"
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/50 to-white" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-transparent to-white/90" />
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,45,120,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,45,120,1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 py-24 md:py-36">
        <div className="flex items-center gap-2 mb-8">
          <Link to="/" className="text-xs text-gray-400 hover:text-primary transition-colors">{t('breadcrumb.home')}</Link>
          <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
          <span className="text-xs text-primary">{t('breadcrumb.about')}</span>
        </div>

        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-glow-pulse" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">{t('aboutPage.hero.tag')}</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-heading font-black text-gray-900 mb-6 leading-tight">
            {t('aboutPage.hero.title')}
            <br />
            <span className="gradient-text">{t('aboutPage.hero.highlight')}</span>
          </h1>

          <p className="text-gray-500 text-lg leading-relaxed max-w-2xl mb-10">
            {t('aboutPage.hero.subtitle1')}
            {t('aboutPage.hero.subtitle2')}
          </p>

          <div className="flex flex-wrap gap-8">
            {[
              { val: t('aboutPage.hero.stats.0.val'), label: t('aboutPage.hero.stats.0.label') },
              { val: t('aboutPage.hero.stats.1.val'), label: t('aboutPage.hero.stats.1.label') },
              { val: t('aboutPage.hero.stats.2.val'), label: t('aboutPage.hero.stats.2.label') },
            ].map((s, i) => (
              <div key={i} className="flex items-baseline gap-2">
                <span className="text-2xl font-heading font-black text-primary">{s.val}</span>
                <span className="text-sm text-gray-400">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </section>
  );
}
